module.exports = __webpack_public_path__ + "media/npc_dota_hero_elder_titan.98413cb5.webm";